import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';

import Layout from './components/Layout';
import ProviderRegistrationForm from './pages/ProviderRegistrationForm';
import AuthorityContactForm from './pages/AuthorityContactForm';
import FacilitiesForm from './pages/final_step/FacilitiesForm';
import ProviderEmpanelment from './pages/home/ProviderEmpanelment';
import SuccessPage from './pages/SuccessPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Router>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<ProviderEmpanelment />} />
        <Route path="step-1" element={<ProviderRegistrationForm />} />
        <Route path="step-2" element={<AuthorityContactForm />} />
        <Route path="step-3" element={<FacilitiesForm />} />
        <Route path="success" element={<SuccessPage />} />
      </Route>
    </Routes>
  </Router>
);

reportWebVitals();
